// Marketing consent of this browser for the Meta Pixel. The app asks on its
// own: the website's Complianz consent does not reach it.

export const CONSENT_STORAGE_KEY = 'novofon_consent';
// Change it when the banner text changes: everyone is asked again.
export const CONSENT_VERSION = '2026-10-30';
// Asked again after a year, like the website's Complianz banner.
export const CONSENT_MAX_AGE_DAYS = 365;

const CONSENT_MAX_AGE_MS = CONSENT_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;

export interface ConsentDecision {
  marketing: boolean;
  version: string;
  /** Milliseconds since the epoch */
  decidedAt: number;
}

/** The stored decision, or null when there is none, it is outdated or expired. */
export const readConsent = (now = Date.now()): ConsentDecision | null => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<ConsentDecision>;
    if (
      typeof value.marketing !== 'boolean' ||
      value.version !== CONSENT_VERSION ||
      typeof value.decidedAt !== 'number' ||
      now - value.decidedAt > CONSENT_MAX_AGE_MS
    ) {
      return null;
    }
    return { marketing: value.marketing, version: value.version, decidedAt: value.decidedAt };
  } catch {
    return null;
  }
};

export const writeConsent = (marketing: boolean, now = Date.now()): ConsentDecision => {
  const decision: ConsentDecision = { marketing, version: CONSENT_VERSION, decidedAt: now };
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(decision));
  } catch {
    // Storage unavailable: the banner asks again on the next visit.
  }
  return decision;
};

export const isValidPixelId = (value: string | null | undefined): value is string =>
  !!value && /^\d+$/.test(value);
